import { ModelBase } from "../abstract/model-base.model";

export class Quota extends ModelBase {

    static override CLASS_NAME: string = 'Quota';

    readonly field!: string;
    readonly quota!: number;
}
